'use strict';

import BaseService from './base.service';

class TasksService extends BaseService {
  static $inject = ['Task', 'SegaUser'];
  Task: any;

  constructor(Task, SegaUser) {
    super(Task, SegaUser);
    Object.assign(this, {
      Task
    });
  }

  async changeDueDate(ids: number[], newDueDate: Date) {
    return this.Task.changeDueDate({ids, newDueDate}).$promise;
  }

  async complete(ids: number[], comments: string) {
    return this.Task.complete({ids, comments}).$promise;
  }

  async createMulti(
    employeeIds: number[], description: string,
    dueDate: Date, operationId: number | null
  ) {
    return this.Task.createMulti({
      employeeIds,
      description,
      dueDate,
      ...(operationId ? { operationId } : {})
    }).$promise;
  }
}
export default TasksService;
